import script from "./uneighteen_page.vue?vue&type=script&setup=true&lang=js"
export * from "./uneighteen_page.vue?vue&type=script&setup=true&lang=js"

import "./uneighteen_page.vue?vue&type=style&index=0&id=c1cd715c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1cd715c"]])

export default __exports__